import React from "react";

export default function InterviewsArticles() {
    return (
        <div className="panel-body body1">
            InterviewsArticles
        </div>
    )
}
